export const TravelIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/travel-colored.svg`
export const BicycleIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/Bicycle.svg`
export const BusIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/Bus.svg`
export const AccidentIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/accident-colored.svg`
export const CreditIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/credit.svg`
export const DeliveryIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/delivery.svg`
export const DeviceIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/device.svg`
export const EcommerceIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/ecommerce.svg`
export const EducationIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/education.svg`
export const ElectronicIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/electronic.svg`
export const FilmIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/film.svg`
export const FireIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/fire.svg`
export const FlightIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/flight.svg`
export const FloodIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/flood.svg`
export const FoodIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/food.svg`
export const GadgetIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/gadget-colored.svg`
export const HealthIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/health-colored.svg`
export const HomeContentIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/home-content.svg`
export const LiabilityIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/liability.svg`
export const LifeIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/life.svg`
export const LifestyleIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/lifestyle.svg`
export const MerchantIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/merchant.svg`
export const OthersIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/others.svg`
export const PropertyIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/property-colored.svg`
export const ShippingIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/shipping.svg`
export const TicketIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/ticket.svg`
export const TrainIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/train.svg`
export const AutoIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/auto-colored.svg`
export const MotorcycleIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/motorcycle.svg`
export const LogisticsIcon = `https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/logistics.svg`

export const categoryIconMap = {
  default: OthersIcon,
  auto: AutoIcon,
  bicycle: BicycleIcon,
  bike: MotorcycleIcon,
  bus: BusIcon,
  car: AutoIcon,
  credit: CreditIcon,
  device: GadgetIcon,
  ecommerce: EcommerceIcon,
  electronic: ElectronicIcon,
  flight: FlightIcon,
  gadget: GadgetIcon,
  health: HealthIcon,
  'home-content': HomeContentIcon,
  liability: LiabilityIcon,
  life: LifeIcon,
  lifestyle: LifestyleIcon,
  logistics: LogisticsIcon,
  merchant: MerchantIcon,
  movies: FilmIcon,
  other: OthersIcon,
  others: OthersIcon,
  'personal-accident': AccidentIcon,
  phone: GadgetIcon,
  property: PropertyIcon,
  shipping: ShippingIcon,
  ticket: TicketIcon,
  train: TrainIcon,
  travel: TravelIcon,
  vehicle: AutoIcon,
  delivery: DeliveryIcon,
  education: EducationIcon,
  fire: FireIcon,
  food: FoodIcon
}

export const getCategoryIcon = (code) => categoryIconMap[code] || categoryIconMap.default
